import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'bp-svg-icons-definitions',
	templateUrl: './svg-icons-definitions.component.html',
	styles: [ ':host { display: none }' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIconsDefinitionsComponent { }
